/**
 * Wind speed for display. The backend always sends wind in km/h (the weather
 * job stores ZENTRA's m/s as km/h); the pour's company picks km/h or mph
 * (CompanyInfo.WindspeedFormat, sent as pour.wind_speed_unit).
 */
export type WindSpeedUnit = 'km/h' | 'mph';

const KMH_PER_MPH = 1.609344;

/** A km/h value in the company's unit, or null without a value. */
export const windInUnit = (kmh: number | null | undefined, unit?: WindSpeedUnit | null): number | null => {
  if (kmh === null || kmh === undefined || Number.isNaN(kmh)) return null;
  return unit === 'mph' ? kmh / KMH_PER_MPH : kmh;
};

/** "12.3 km/h" / "7.6 mph", or "" without a value. */
export const formatWind = (kmh: number | null | undefined, unit?: WindSpeedUnit | null): string => {
  const value = windInUnit(kmh, unit);
  return value === null ? '' : `${value.toFixed(1)} ${unit === 'mph' ? 'mph' : 'km/h'}`;
};
